module.exports = __webpack_public_path__ + "static/media/Bintang Kecil - Baru (2).65fb46db.png";